import Resources from './helpers/resources';
import { getLocale } from './i18n';
import { getJWTToken } from './helpers/utils';

export const getLicenceSummaryByProduct = productId =>
    (Resources.productLicenses.get()
        .headers({ Locale: getLocale() })
        .withParams({ productId })
        .send());

export const getStudentsByProduct = productId =>
    (Resources.students.get()
        .headers({ Locale: getLocale() })
        .withParams({ productId }).send());

export const getYearGroups = () =>
    (Resources.yearGroups.get()
        .headers({ Locale: getLocale() })
        .send());

export const getCountryYearGroups = ({ countryCode }) =>
    (Resources.countryYearGroups)
        .get()
        .headers({ Locale: getLocale() })
        .withParams({ countryCode })
        .send();

export const postStudentsPriorDownload = ({ students }) =>
    (Resources.studentsCsv)
        .post()
        .headers({ Locale: getLocale() })
        .withBody(students)
        .send();

export const downloadTemplateFile = templateType =>
    (Resources.downloadTemplateFile)
        .get(templateType)
        .headers({ Locale: getLocale() })
        .send();

export const quickUpload = ({ productId, fileContent }) =>
    (Resources.quickUpload)
        .post({ productId })
        .headers({ Locale: getLocale() })
        .withBody(fileContent)
        .send();

export const getClassrooms = productId =>
    (Resources.classrooms.get({ productId })
        .headers({ Locale: getLocale() })
        .send());

export const unAssignStudents = userRelationship =>
    (Resources.unassignStudents)
        .put()
        .headers({ Locale: getLocale() })
        .withBody(userRelationship)
        .send();

export const bulkPasswordChangeStudents = bulkPasswordChange =>
    (Resources.bulkPasswordChangeStudents)
        .put()
        .headers({ Locale: getLocale() })
        .withBody(bulkPasswordChange)
        .send();

export const bulkPasswordChangeTeachers = bulkPasswordChange =>
    (Resources.bulkPasswordChangeTeachers)
        .put()
        .headers({ Locale: getLocale() })
        .withBody(bulkPasswordChange)
        .send();

export const downloadStudentsSignInCards = (productId, studentSignInCardsData) =>
    (Resources.classStudentsSignInCards)
        .post({ productId })
        .headers({ Locale: getLocale() })
        .withBody(studentSignInCardsData)
        .send();

export const addStudent = student => (Resources.students)
    .post()
    .headers({ Locale: getLocale() })
    .withBody(student)
    .send();

export const getStudentByUserProfileId = (productId, userProfileId) =>
    (Resources.getStudents)
        .get({ userProfileId })
        .headers({ Locale: getLocale() })
        .withParams({ productId })
        .send();

export const getTeachersByProduct = productId =>
    (Resources.teachers.get()
        .headers({ Locale: getLocale() })
        .withParams({ productId })
        .send());

export const postTeachersPriorDownload = ({ teachers }) =>
    (Resources.teachersCsv)
        .post()
        .headers({ Locale: getLocale() })
        .withBody(teachers)
        .send();

export const unAssignTeachers = userRelationship =>
    (Resources.unassignTeachers)
        .put()
        .headers({ Locale: getLocale() })
        .withBody(userRelationship)
        .send();

export const downloadTeachersSignInCards = (productId, teacherSignInCardsData) =>
    (Resources.teachersSignInCards)
        .post({ productId })
        .headers({ Locale: getLocale() })
        .withBody(teacherSignInCardsData)
        .send();

export const addTeacher = ({ teacher }) =>
    (Resources.addTeacher)
        .post()
        .headers({ Locale: getLocale() })
        .withBody(teacher)
        .send();

export const getTeacherByUserProfileId = (productId, userProfileId) =>
    (Resources.getTeachers)
        .get({ userProfileId })
        .headers({ Locale: getLocale() })
        .withParams({ productId })
        .send();
export const editStudent = student =>
    (Resources.students)
        .put()
        .headers({ Locale: getLocale() })
        .withBody(student)
        .send();

export const editTeacher = teacher =>
    (Resources.teachers)
        .put()
        .headers({ Locale: getLocale() })
        .withBody(teacher)
        .send();

export const downloadClassroomStudentsSignInCards = ({ productId, classroomId, SignInCardPageSizeType }) =>
    (Resources.classStudentsSignInCards)
        .post({ productId })
        .headers({ Locale: getLocale() })
        .withBody({ classroomId, SignInCardPageSizeType })
        .send();

export const downloadClassroomsStudentsSignInCards = ({ productId, studentSignInCardsData }) =>
    (Resources.classroomsStudentsSignInCards)
        .post({ productId })
        .headers({ Locale: getLocale() })
        .withBody(studentSignInCardsData)
        .send();

export const getStudentClassroomsRelation = (userProfileId, productId) =>
    (Resources.studentClassroomsRelation)
        .get({ userProfileId, productId })
        .headers({ Locale: getLocale() })
        .send();

export const getTeacherClassroomsRelation = (userProfileId, productId) =>
    (Resources.teacherClassroomsRelation)
        .get({ userProfileId, productId })
        .headers({ Locale: getLocale() })
        .send();

export const assignStudentClassrooms = (assignedClassrooms, userProfileId, productId) =>
    (Resources.studentClassroomsRelation)
        .put({ userProfileId, productId })
        .headers({ Locale: getLocale() })
        .withBody(assignedClassrooms)
        .send();

export const assignTeacherClassrooms = (assignedClassrooms, userProfileId, productId) =>
    (Resources.teacherClassroomsRelation)
        .put({ userProfileId, productId })
        .headers({ Locale: getLocale() })
        .withBody(assignedClassrooms)
        .send();

export const deleteStudents = userProfileIds =>
    (Resources.deleteStudents)
        .delete()
        .headers({ Locale: getLocale() })
        .withBody(userProfileIds)
        .send();

export const deleteTeachers = userProfileIds =>
    (Resources.deleteTeachers)
        .delete()
        .headers({ Locale: getLocale() })
        .withBody(userProfileIds)
        .send();

export const getCourseCountries = productId =>
    (Resources.getCourseCountries)
        .get({ productId })
        .headers({ Locale: getLocale() })
        .withBody(productId)
        .send();

export const getUpfCourseCountries = (productId, countryCourseType) =>
    (Resources.getCourseCountries)
        .get({ productId, countryCourseType })
        .headers({ Locale: getLocale() })
        .withBody(productId)
        .send();

export const getConquestCourseCountries = (productId, countryCourseType) =>
    (Resources.getCourseCountries)
        .get({ productId, countryCourseType })
        .headers({ Locale: getLocale() })
        .withBody(productId)
        .send();

export const getProductCourses = (countryCode, productId, yearGroup) =>
    (Resources.getProductCourses)
        .get({ countryCode, productId, yearGroup })
        .headers({ Locale: getLocale() })
        .withBody(countryCode, productId, yearGroup)
        .send();

export const getSchoolCourses = yearGroup =>
    (Resources.getSchoolCourses)
        .get({ yearGroup })
        .headers({ Locale: getLocale() })
        .withBody(yearGroup)
        .send();

export const postClassesPriorDownload = classInfo =>
    (Resources.classesCsv)
        .post()
        .headers({ Locale: getLocale() })
        .withBody(classInfo)
        .send();

export const addClass = ({ name, productId, courseId, teacherProfileIds, yearGroupEnum, upfCourseId, conquestCourseId, useUpfSchoolDefault }) =>
    (Resources.addClass)
        .post()
        .headers({ Locale: getLocale() })
        .withBody({ name, productId, courseId, teacherProfileIds, yearGroupEnum, upfCourseId, conquestCourseId, useUpfSchoolDefault })
        .send();

export const updateClassroomGroup = (newGroupName, classroomId, groupId) =>
    (Resources.updateClassroomGroup)
        .put({ classroomId, groupId })
        .headers({ Locale: getLocale() })
        .withBody({ newGroupName })
        .send();

export const getClassroomById = classroomId => (Resources.getClassById)
    .get({ classroomId })
    .headers({ Locale: getLocale() })
    .withParams()
    .send();

export const updateClass = ({ classroomId, newClassroomName, newYearGroup }) =>
    (Resources.updateClass)
        .put({ classroomId })
        .headers({ Locale: getLocale() })
        .withBody({ newClassroomName, newYearGroup })
        .send();

export const classroomUserRelation = teacherClassroomMapping =>
    (Resources.classroomUserRelation)
        .put()
        .headers({ Locale: getLocale() })
        .withBody(teacherClassroomMapping)
        .send();

export const deleteClassroomGroup = (classroomId, groupId) =>
    (Resources.deleteClassroomGroup)
        .delete({ classroomId, groupId })
        .headers({ Locale: getLocale() })
        .send();

export const changeClassroomCourse = (classroomId, groupId, newCourseId, newUpfCourseId, newConquestCourseId, useUpfSchoolDefault = false) =>
    (Resources.changeClassroomCourse)
        .put({ classroomId, groupId })
        .headers({ Locale: getLocale() })
        .withBody({})
        .withParams({ newCourseId, newUpfCourseId, newConquestCourseId, useUpfSchoolDefault })
        .send();

export const getStudentsByClassroomId = classroomId =>
    (Resources.getStudentsByClassroomId)
        .get({ classroomId })
        .headers({ Locale: getLocale() })
        .send();

export const addGroup = (classroomId, name) =>
    (Resources.addGroup)
        .post({ classroomId })
        .headers({ Locale: getLocale() })
        .withBody({})
        .withParams({ name })
        .send();

export const getClassroomGroups = classroomId =>
    (Resources.getClassroomGroups)
        .get({ classroomId })
        .headers({ Locale: getLocale() })
        .withBody({})
        .send();

export const moveStudents = (moveStudentsCommand, classroomId) =>
    (Resources.moveStudents)
        .put({ classroomId })
        .headers({ Locale: getLocale() })
        .withBody(moveStudentsCommand)
        .send();

export const deleteClassrooms = classroomIds =>
    (Resources.deleteClassrooms)
        .delete()
        .headers({ Locale: getLocale() })
        .withBody(classroomIds)
        .send();

export const changeCourseCarryOver = (classroomId, groupId, newCourseId, newUpfCourseId, taskActionType, courses, newConquestCourseId) =>
    (Resources.changeCourseCarryOver)
        .put({ classroomId, groupId })
        .headers({ Locale: getLocale() })
        .withBody(courses)
        .withParams({ newCourseId, newUpfCourseId, taskActionType, newConquestCourseId })
        .raw()
        .send();

export const verifyRollover = (productId, content) =>
    (Resources.verifyRollOver)
        .post({ productId })
        .headers({ Locale: getLocale() })
        .withBody(content)
        .send();

export const downloadSchoolRollData = (productId, includeUnassignedStudents, includeBulkTransfer) =>
    (Resources.downloadSchoolRollData)
        .get({ productId })
        .headers({ Locale: getLocale() })
        .withParams({ includeUnassignedStudents, includeBulkTransfer })
        .send();

export const performRollover = (productId, schoolRollover) =>
    (Resources.performRollover)
        .post({ productId })
        .headers({ Locale: getLocale() })
        .withBody(schoolRollover)
        .send();

export const extendingResultsStatus = productId =>
    (Resources.extendingResultsStatus)
        .get(productId)
        .headers({ Locale: getLocale() })
        .withBody()
        .send();

export const extendResults = (productId, yeargroups) =>
    (Resources.extendResults)
        .post({ productId })
        .headers({ Locale: getLocale() })
        .withBody(yeargroups)
        .send();

export const getDefaultCourses = productId =>
    (Resources.getDefaultCourses).get(productId)
        .headers({ Locale: getLocale() })
        .send();

export const getAcademicYear = () =>
    (Resources.getAcademicYear)
        .get()
        .headers({ Locale: getLocale() })
        .send();

export const getCertificatesSummary = request =>
    (Resources.getCertificatesSummary)
        .get()
        .headers({ Locale: getLocale() })
        .withBody(request)
        .send();

export const downloadCertificates = request =>
    (Resources.downloadCertificates)
        .post()
        .headers({ Locale: getLocale() })
        .withBody(request)
        .send();


export const getCourse = courseId =>
    (Resources.getCourse).get(courseId)
        .headers({ Locale: getLocale() })
        .send();

export const saveSchoolDefaultCourses = (productId, yearGroupCourses) =>
    (Resources.saveSchoolDefaultCourses)
        .post({ productId })
        .headers({ Locale: getLocale() })
        .withBody(yearGroupCourses)
        .raw()
        .send();

export const checkCommonTasks = ({ classroomId, groupId, courseId }) =>
    (Resources.checkCommonTasks.get({ classroomId, groupId })
        .headers({ Locale: getLocale() })
        .withParams({ courseId })
        .send());

export const assignCourses = changeCourseRequests =>
    (Resources.assignCourses)
        .put()
        .headers({ Locale: getLocale() })
        .withBody(changeCourseRequests)
        .raw()
        .send();

export const getTeacherAuthToken = (userProfileType, userProfileId) =>
    (Resources.getTeacherAuthToken)
        .get({ userProfileType, userProfileId })
        .headers({
            Locale: getLocale(),
            Authorization: getJWTToken()
        })
        .send();

export const sendTeacherPassword = request =>
    (Resources.sendTeacherPassword)
        .post()
        .headers({ Locale: getLocale() })
        .withBody(request)
        .send();

export const sendVerificationEmail = request =>
    (Resources.sendVerificationEmail)
        .post()
        .headers({ Locale: getLocale() })
        .withBody(request)
        .send();

export const sendVerificationEmails = request =>
    (Resources.sendVerificationEmails)
        .post()
        .headers({ Locale: getLocale() })
        .withBody(request)
        .send();

export const getFilteredCourses = (countryCode, productId, yearGroup, selectGenericCourses, includeGlobalCourses) =>
    (Resources.getFilteredCourses)
        .post()
        .headers({ Locale: getLocale() })
        .withBody(countryCode, productId, yearGroup, selectGenericCourses, includeGlobalCourses)
        .send();

export const getConquestFilteredCourses = ({ productId, countryCode, yearGroup }) => (Resources.getConquestFilteredCourses)
    .get()
    .headers({ Locale: getLocale() })
    .withParams({ productId, countryCode, yearGroup })
    .send();



// WEBPACK FOOTER //
// ./app/api.js